import ContentLoader from 'react-content-loader';

const TravelPolicyLoader = () => (
	<ContentLoader width={570} height={50} viewBox="0 0 570 50" backgroundColor="#dbffee80" foregroundColor="#dbffeedd">
		<rect x="0" y="0" rx="4" ry="4" width="570" height="50" />
	</ContentLoader>
);

export default TravelPolicyLoader;
